import { QuestionCircleOutlined } from '@ant-design/icons-vue';
import {message, Modal} from 'ant-design-vue';
import {createVNode} from 'vue';
export function messageTips(tips,type) {    
    message.config({top: '48%',});
    switch(type){
        case 1:    
            message.error(tips);
        break;
        case 2:
            message.warning(tips);  
        break;
        case 3:
            message.success(tips);   
        break;
        default:break;
    }
}

export function confirmLogin() {
    Modal.confirm({
        title: '提示',
        icon: createVNode(QuestionCircleOutlined),
        content: '此功能需要登录个人账号，是否立即登录？',
        okText: '登录',
        centered:true,
        cancelText: '以后再说',
        onOk() {
            let url = window.location.href;
            setCookie('locationTarget',url,{time:1});
            //打回登录 哈希带#
            window.location.href = '#/login/login_basic';
        },
        onCancel() {},
    });
}

export function timeFormat(date,type) {
    let newDate = new Date(date);
    let year = newDate.getFullYear();
    let month = newDate.getMonth()+1;
    if(month<10) {
        month='0'+month;
    }
    let dates = newDate.getDate();
    if(dates<10) {
        dates='0'+dates;
    }
    let hours = newDate.getHours();
    if(hours<10) {
        hours='0'+hours;
    }
    let minute = newDate.getMinutes();
    if(minute<10) {
        minute='0'+minute;
    }
    let seconds = newDate.getSeconds();
    if(seconds<10) {
        seconds='0'+seconds;
    }
    if(type) {
        return year+'-'+month+'-'+dates+' '+hours+':'+minute;
    } else {
        return year+'-'+month+'-'+dates+' '+hours+':'+minute+':'+seconds;
    }
}

export function checkIsInt(nubmer) { 
    var re = parseInt(nubmer).toString() === 'NaN';
    return !re;
}


/**
 * 手机号码正则验证
 * @param value
 */
export function isPhone(value) {
    var reg = /^1[0-9]{10}$/;
    if (!reg.test(value)) {
        return false;
    } else {
        return true;
    }
}

/**
 * 邮箱正则验证
 * @param value
 */
export function isEmail(value) {
    var reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
    if (!reg.test(value)) {
        return false;
    } else {
        return true;
    }
}

//获取cookie
export function getCookie(sname){
    var acookie = document.cookie.split("; ");
    for (var i = 0; i < acookie.length; i++) {
        var arr = acookie[i].split("=");
        if (sname === arr[0]) {
            if (arr.length > 1){
                var sid = unescape(arr[1]);
                if(sname === 'z_sid'){
                    setCookie(sname,sid,{time:1});
                }
                return sid;
            } else{
                return "";
            }
        }
    }
    return "";
}
//设置cookie
export function setCookie(name,value,option){
    var seconds = option.time*24*60*60 || 0;
    var expires = "";
    if (seconds !== 0 ) {      //设置cookie生存时间
        var date = new Date();
        date.setTime(date.getTime()+(seconds*1000));
        expires = "; expires="+date.toGMTString();
    }
    var path = option.path||'/';
    document.cookie = name+"="+escape(value)+expires+"; path="+path;
}
//删除cookie
export function delCookie(name) {
    setCookie(name,'',{time:-1});
}

export function setSessionItem(key, value) {
    if (typeof (value) !== 'string') {
        value = JSON.stringify(value);
    }
    return window.sessionStorage.setItem(key, value);
}
//设置localStorage
export function setLocalItem(key, value) {
    if (typeof (value) !== 'string') {
        value = JSON.stringify(value);
    }
    return window.localStorage.setItem(key, value);
}
export function getSessionItem(key) {
    var string = window.sessionStorage.getItem(key);
    try {
        var obj = JSON.parse(string);
        if (typeof obj === 'object' && obj) {
            return obj;
        } else {
            if (string === 'null') {
                return null;
            } else {
                return string;
            }
        }
    } catch (e) {
        if (string === 'null') {
            return null;
        } else {
            return string;
        }
    }
}
export function getLocalItem(key) {
    var string = window.localStorage.getItem(key);
    try {
        var obj = JSON.parse(string);
        if (typeof obj === 'object' && obj) {
            return obj;
        } else {
            if (string === 'null') {
                return null;
            } else {
                return string;
            }
        }
    } catch (e) {
        if (string === 'null') {
            return null;
        } else {
            return string;
        }
    }
}
export function delSessionItem(name) {
    window.sessionStorage.removeItem(name);
}
export function delLocalItem(name) {
    window.localStorage.removeItem(name);
}

export const htmlToText = (htmlStr)=>{
    return htmlStr.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/ /g,' ').replace(/>/g,' ').replace(/&nbsp;/g,'').replace(/&quot;/g,'"').replace(/&gt;/g,'>').replace(/&lt;/g,'<').replace(/\s+/g,'');
} 

export const thousandSplit = function (num) {
    return ("" + num).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,")
}

/**
 * 昵称正则验证
 * @param value
 * 支持中英文、数字、“_”或减号
 */
 export function isName(value) {
    var myregex =/^[0-9A-Za-z\u4e00-\u9fa5_-]+$/;
    if (!myregex.test(value)){
        return false;
    }else{
        return true;
    }
}

export function numWan(value) {
    if(value>10000) {
        return Math.floor(value/1000)/10+'万';
    } else {
        return value;
    }
}